import { inject, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { IsRootedResult, RootDetection } from '@capawesome/capacitor-root-detection';
import { datadogRum } from '@datadog/browser-rum';
import { UIDialogService } from '@ui/components';
import { EnvironmentService } from '@util/environment';
import { SharedRootedDeviceDialogComponent } from '../components/rooted-device-dialog/rooted-device-dialog.component';

@Injectable({ providedIn: 'root' })
export class SharedRootDetectionService {
  private readonly dialogService = inject(UIDialogService);
  private readonly environmentService = inject(EnvironmentService);
  private dialogShown = false;

  init(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    if (!this.environmentService.environment.rootDetectionEnabled) {
      return;
    }

    RootDetection.isRooted()
      .then(({ rooted }: IsRootedResult) => {
        if (rooted) {
          this.showRootedDialog();
        }
      })
      .catch((error: unknown) => {
        // Fail open - root detection failure must not block app usage, but report it
        // so a missing native plugin or a plugin crash is visible in production.
        datadogRum.addError(error, { context: 'root-detection' });
      });
  }

  private showRootedDialog(): void {
    if (this.dialogShown) {
      return;
    }
    this.dialogShown = true;
    // Require an explicit Dismiss - a security warning must not be lost to a stray backdrop tap.
    this.dialogService.open(SharedRootedDeviceDialogComponent, { disableClose: true });
  }
}
